import { createContext, useContext, useState, useEffect } from "react";
import API, { formatError } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    API.get("/api/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await API.post("/api/auth/login", { identifier, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, whatsapp, password, role) => {
    const { data } = await API.post("/api/auth/register", { name, whatsapp, password, role });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await API.post("/api/auth/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
